import React, { useEffect, useState } from "react";

const links = [
  { label: "AI Agents", href: "#agents" },
  { label: "What We Solve", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Results", href: "#results" },
  { label: "About", href: "#about" },
  { label: "Live Demos", href: "#demos" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <nav
          className={`flex items-center justify-between rounded-full px-5 py-3 transition-all duration-500 ${
            scrolled ? "glass" : "bg-white/[0.04] backdrop-blur-sm border border-white/10"
          }`}
        >
          <a href="#top" data-testid="nav-logo" className="flex items-center gap-2.5">
            <span className="relative w-14 h-14 rounded-full overflow-hidden flex items-center justify-center bg-[var(--night)] ring-1 ring-[var(--camel)]/40 shadow-[0_6px_14px_-6px_rgba(69,102,199,0.45)]">
              <img
                src="/duaura-logo.png"
                alt="Duaura"
                className="w-full h-full object-contain p-1"
              />
            </span>
            <span className={`font-serif text-[28px] font-medium tracking-tight transition-colors duration-500 ${
              scrolled ? "text-[var(--ink)]" : "text-white"
            }`}>
              Duaura
            </span>
          </a>

          <ul className="hidden md:flex items-center gap-7">
            {links.map((l) => (
              <li key={l.href}>
                {l.href === "#demos" ? (
                  <a
                    data-testid="nav-link-demos"
                    href={l.href}
                    className="relative inline-flex items-center gap-2 rounded-full pl-2.5 pr-3.5 py-1.5 text-[14.5px] font-medium text-[var(--night)] shadow-[0_0_0_3px_rgba(232,206,149,0.22),0_8px_20px_-8px_rgba(199,155,85,0.7)] hover:-translate-y-px transition-transform"
                    style={{ background: "linear-gradient(135deg, #F3DFAE 0%, #E8CE95 50%, #C79B55 100%)" }}
                  >
                    <span className="relative flex w-2 h-2">
                      <span className="absolute inline-flex w-full h-full rounded-full bg-[#B4232A] opacity-60 animate-ping" />
                      <span className="relative inline-flex w-2 h-2 rounded-full bg-[#B4232A]" />
                    </span>
                    {l.label}
                  </a>
                ) : (
                  <a
                    data-testid={`nav-link-${l.href.replace("#", "")}`}
                    href={l.href}
                    className={`text-[15px] link-shimmer transition-colors duration-500 ${
                      scrolled
                        ? "text-[var(--ink-soft)] hover:text-[var(--ink)]"
                        : "text-white/80 hover:text-white"
                    }`}
                  >
                    {l.label}
                  </a>
                )}
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-2">
            <a
              data-testid="nav-cta-book"
              href="#book"
              className="hidden sm:inline-flex btn-cobalt rounded-full text-[15px] font-medium px-5 py-3"
            >
              Book free call
              <span className="ml-2 -mr-0.5">→</span>
            </a>
            <button
              data-testid="nav-mobile-toggle"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden w-10 h-10 rounded-full border border-[var(--line)] bg-white/70 flex items-center justify-center"
              aria-label="Toggle menu"
            >
              <span className="block w-4 h-[1.5px] bg-[var(--ink)] relative before:content-[''] before:absolute before:left-0 before:-top-1.5 before:w-4 before:h-[1.5px] before:bg-[var(--ink)] after:content-[''] after:absolute after:left-0 after:top-1.5 after:w-4 after:h-[1.5px] after:bg-[var(--ink)]" />
            </button>
          </div>
        </nav>

        {open && (
          <div data-testid="nav-mobile-menu" className="md:hidden mt-3 glass rounded-3xl p-5">
            <ul className="flex flex-col gap-3">
              {links.map((l) => (
                <li key={l.href}>
                  <a
                    onClick={() => setOpen(false)}
                    href={l.href}
                    className={`block py-2 text-[17px] ${l.href === "#demos" ? "font-medium text-[#A8823A]" : "text-[var(--ink)]"}`}
                  >
                    {l.label}{l.href === "#demos" && " ●"}
                  </a>
                </li>
              ))}
              <a
                onClick={() => setOpen(false)}
                href="#book"
                className="btn-cobalt rounded-full text-center text-[16px] font-medium px-4 py-3 mt-2"
              >
                Book free call →
              </a>
            </ul>
          </div>
        )}
      </div>
    </header>
  );
}
